export default function MODAL_BODY_SPACE(size, isCentered = false, isSidebar = false) {
  if (isSidebar) return 'p-0';
  if (isCentered) return 'p-4 pb-6';

  switch (size) {
    case 'full':
      return 'px-6 pt-4';
    case 'large':
      return 'px-36 pt-4';
    case 'medium':
    case 'small':
      return 'p-5';
    default:
      return '';
  }
}
